// extracted by mini-css-extract-plugin
var _1 = "TabButton__active--r1tEN TabButton__main--xvQMf CoreGeneral__robotoSlab--X8lgW general__shadow--ifbUf fontSize__profileText--q79uE";
var _2 = "TabButton__bg--KXcx0 general__bg--twM_t";
var _3 = "TabButton__content--xoDzF";
var _4 = "TabButton__demoHighlight--xL0rN TabButton__main--xvQMf CoreGeneral__robotoSlab--X8lgW general__shadow--ifbUf fontSize__profileText--q79uE";
var _5 = "TabButton__main--xvQMf CoreGeneral__robotoSlab--X8lgW general__shadow--ifbUf fontSize__profileText--q79uE";
var _6 = "TabButton__tabBg--RLj6Y";
var _7 = "TabButton__tabBgActive--Qc9LN";
var _8 = "TabButton__tabBorder--SM9D8";
var _9 = "TabButton__tabBorderActive--IXrbR";
export { _1 as "active", _2 as "bg", _3 as "content", _4 as "demoHighlight", _5 as "main", _6 as "tabBg", _7 as "tabBgActive", _8 as "tabBorder", _9 as "tabBorderActive" }
